const getPreviousMonthDates = () => {
    const monthNames = [
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];
    const today = new Date();
    const lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
    const firstDay = new Date(lastDay.getFullYear(), lastDay.getMonth(), 1);
    const monthName = monthNames[lastDay.getMonth()];
    return {
        firstDay,
        lastDay,
        monthName
    };
};
export default getPreviousMonthDates;
